import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import SafeFeedbackFormularioGrid from './SafeFeedbackFormularioGrid.jsx'
import {FormattedMessage, injectIntl} from 'react-intl';

class SafeFeedbackFormulario extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="SafeFeedbackFormulario.formularios.label_administracion_relatos" defaultMessage="Administración de Relatos"/></h3>
      				</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={SafeFeedbackFormularioGrid} />
					</Switch>
				</div>
			</div>
	    );
  	}
}

export default injectIntl(SafeFeedbackFormulario);